var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 0H2.125C1.59457 0 1.08586 0.223109 0.710786 0.620244C0.335714 1.01738 0.125 1.55601 0.125 2.11765V12.7059C0.125 13.2675 0.335714 13.8061 0.710786 14.2033C1.08586 14.6004 1.59457 14.8235 2.125 14.8235H6.125L9.125 18L12.125 14.8235H16.125C16.6554 14.8235 17.1641 14.6004 17.5392 14.2033C17.9143 13.8061 18.125 13.2675 18.125 12.7059V2.11765C18.125 1.55601 17.9143 1.01738 17.5392 0.620244C17.1641 0.223109 16.6554 0 16.125 0Z",
    fill: "#4A81E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 9.52942H17.625",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanFilled);
export default __webpack_public_path__ + "static/media/plan_filled.152c99aaab902d7e97b5b244621370f4.svg";
export { ForwardRef as ReactComponent };